import React, { useEffect } from 'react';
import { motion } from 'framer-motion';

const Imprint = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <main className="pt-32 pb-24 bg-zinc-950 min-h-screen selection:bg-orange-500 selection:text-zinc-950">
      <div className="container mx-auto px-6 md:px-12 max-w-4xl">
        <motion.div 
          initial={{ opacity: 0, y: 20 }} 
          animate={{ opacity: 1, y: 0 }} 
          transition={{ duration: 0.5 }}
        >
          <h1 className="text-4xl md:text-6xl font-black uppercase tracking-tighter text-white mb-4">
            Impressum<span className="text-orange-500">.</span>
          </h1>
          <div className="w-20 h-2 bg-orange-500 mb-12"></div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 text-zinc-400">
            <section className="space-y-8">
              <div>
                <h2 className="text-xl font-bold text-white uppercase tracking-wider mb-4 border-l-4 border-orange-500 pl-4">
                  Angaben gemäß § 5 TMG
                </h2>
                <p className="leading-relaxed text-lg">
                  Valeri Rudt<br />
                  Westring 9a<br />
                  59423 Unna<br />
                  Deutschland
                </p>
              </div>

              <div>
                <h2 className="text-xl font-bold text-white uppercase tracking-wider mb-4 border-l-4 border-orange-500 pl-4">
                  Kontakt
                </h2>
                <p className="leading-relaxed text-lg">
                  E-Mail: <a href="mailto:info@valerirudtmedia.de" className="text-orange-500 hover:text-white transition-colors underline decoration-orange-500/30">info@valerirudtmedia.de</a>
                </p>
              </div>
            </section>

            <section className="space-y-8">
              <div>
                <h2 className="text-xl font-bold text-white uppercase tracking-wider mb-4 border-l-4 border-orange-500 pl-4">
                  Umsatzsteuer-ID
                </h2>
                <p className="leading-relaxed">
                  Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz:<br />
                  <span className="text-white font-mono bg-zinc-900 px-2 py-1 rounded mt-2 inline-block border border-zinc-800 tracking-wider">
                    DE441656171
                  </span>
                </p>
              </div>

              <div>
                <h2 className="text-xl font-bold text-white uppercase tracking-wider mb-4 border-l-4 border-orange-500 pl-4">
                  Redaktionell verantwortlich
                </h2>
                <p className="leading-relaxed">
                  Valeri Rudt<br />
                  Westring 9a<br />
                  59423 Unna
                </p>
              </div>
            </section>
          </div>

          <div className="mt-20 pt-12 border-t border-zinc-900 text-zinc-500 text-sm space-y-12">
            <section className="max-w-3xl">
              <h3 className="text-zinc-300 font-bold uppercase tracking-widest text-xs mb-3">
                Verbraucherstreitbeilegung / Universalschlichtungsstelle
              </h3>
              <p className="leading-relaxed">
                Wir nehmen an einem Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teil. Zuständig ist die Universalschlichtungsstelle des Zentrums für Schlichtung e.V., Straßburger Straße 8, 77694 Kehl am Rhein (<a href="https://www.verbraucher-schlichter.de" target="_blank" rel="noopener noreferrer" className="text-orange-500 hover:text-white">https://www.verbraucher-schlichter.de</a>).
              </p>
            </section>

            <section className="max-w-3xl">
              <h3 className="text-zinc-300 font-bold uppercase tracking-widest text-xs mb-3">
                Zentrale Kontaktstelle nach dem Digital Services Act (DSA)
              </h3>
              <p className="leading-relaxed mb-2">
                Unsere zentrale Kontaktstelle für Nutzer und Behörden nach Art. 11, 12 DSA erreichen Sie wie folgt:
              </p>
              <p className="mb-1">E-Mail: <span className="text-zinc-300 font-medium">info@valerirudtmedia.de</span></p>
              <p className="mb-4">Sonstige Kontaktwege: <span className="text-zinc-300 font-medium">Instagram DM</span></p>
              <p className="text-xs font-bold mb-1">Verfügbare Sprachen:</p>
              <p>Deutsch, Englisch, Russisch.</p>
            </section>
          </div>
        </motion.div>
      </div>
    </main>
  );
};

export default Imprint;